import { render, staticRenderFns } from "./FormDownload.vue?vue&type=template&id=52de0e40&scoped=true"
import script from "./FormDownload.vue?vue&type=script&lang=ts"
export * from "./FormDownload.vue?vue&type=script&lang=ts"
import style0 from "./FormDownload.vue?vue&type=style&index=0&id=52de0e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52de0e40",
  null
  
)

export default component.exports